import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MyInputNumeric } from ".";
import SearchableDropdown from "./SearchableDropdown";
import { myUtilities } from "../../Utils";

export default function CanadianRoutingNumberFields({
  invoiceData,
  paymentData,
}) {
  const [value, setValue] = useState("");

  return (
    <Col>
      <Container className="payment-element-container">
        <Row>
          <Col className="payment-element-header">
            {myUtilities.accountSpecificLanguage(
              "ACH.Form.Header.transitNumber",
              "Transit Branch Number"
            )}
            <span class="red-asterisk">*</span>
          </Col>
          <Col className="payment-element-header payment-element-header2">
            {myUtilities.accountSpecificLanguage(
              "ACH.Form.Header.FinancialInstituteNumber",
              "Financial Institute Number"
            )}
            <span class="red-asterisk">*</span>
          </Col>
        </Row>
        <Row>
          <Col className="payment-element-value">
            <Container>
              <Row>
                <Col>
                  {" "}
                  <MyInputNumeric name={"transitNumber"} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <hr className="payment-input-label-line" />
                </Col>
              </Row>
            </Container>
          </Col>
          <Col className="payment-element-value">
            <SearchableDropdown
              options={
                invoiceData.financialInstitutionDropdown === undefined ||
                typeof invoiceData.financialInstitutionDropdown !== "object"
                  ? []
                  : invoiceData.financialInstitutionDropdown
              }
              label="name"
              id="id"
              selectedVal={value}
              handleChange={(label, id) => {
                setValue(label);
                paymentData.setFinancialInstituteNumber(
                  id,
                  invoiceData.financialInstitutionDetails
                );
              }}
            />
          </Col>
        </Row>
      </Container>
    </Col>
  );
}
